import SmallProductCard from './SmallProductCard';

export default SmallProductCard
